import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { When } from 'react-if';
import { GlobalToken, theme } from 'antd';

import { AlertsWidget } from '@/comp/MapBuilder/components/AlertsWidget';
import { Ports } from '@/comp/MapBuilder/components/Ports';

const { useToken } = theme;

export const DummyNodeWidget = observer(({ node, engine, width, height }) => {
  const { token } = useToken();
  return (
    <Container width={width} height={height}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <g fill="none" fillRule="evenodd">
          <g>
            <g transform="translate(-647 -328) translate(647 328)">
              <circle id="background" cx="14" cy="14" r="14" fill={token.colorBorder} />
              <path
                fill={token.colorBorder}
                d="M23.106 16.553C21.313 20.923 17.016 24 12 24c-2.909 0-5.576-1.035-7.653-2.757zM2.15 5.146l21.769 5.443c.054.463.082.934.082 1.411 0 .795-.077 1.572-.225 2.324L2.705 19.59C1.016 17.523 0 14.88 0 12c0-2.548.794-4.91 2.149-6.854zM12 0c5.377 0 9.929 3.537 11.454 8.411L3.586 3.444C5.752 1.314 8.722 0 12 0z"
                transform="translate(2 2)"
              />
            </g>
          </g>
        </g>
      </svg>

      <When condition={!!engine}>
        <Ports node={node} engine={engine} width={width} height={height} />
      </When>

      <AlertsWidget alerts={node.alerts} className="alerts-widget" />
    </Container>
  );
});

interface ContainerProps {
  width: number;
  height: number;
  theme: { token: GlobalToken };
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  .name {
    position: absolute;
    top: -23px;
    left: 50%;
    transform: translate(-50%, 0px);
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    white-space: nowrap;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  .alerts-widget {
    position: absolute;
    left: 50%;
    bottom: -25px;
    transform: translate(-50%, 0px);
  }
`;
